import React, { useEffect, useState } from "react";
import IconeFilter from "../assets/icons/hamburger-menu-svgrepo.svg";
import IconeHome from "../assets/icons/home-svgrepo-com.svg";

import IconeLoupe from "../assets/icons/search-left-1506-svgrepo.svg";
import IconeUser from "../assets/icons/user-svgrepo.svg";
import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";
import logo from "../assets/Images/imageLogo_bgRev.png";
import logoGoogle from "../assets/icons/google-svgrepo-com.svg";
import logoFacebook from "../assets/icons/facebook-color-svgrepo-com.svg";
import LogoWhatSapp from "../assets/icons/whatsapp-svgrepo-com.svg";
import {
  IoIosArrowDown,
  IoIosArrowForward,
  IoMdHeartEmpty
} from "react-icons/io";
import { TbLocationSearch } from "react-icons/tb";
import { useSelector } from "react-redux";
import { TailSpin, ThreeDots } from "react-loader-spinner";
import arrowDown from "../assets/icons/down-arrow-5-svgrepo-com.svg";
import { jwtDecode } from "jwt-decode";
import { NavLink, useNavigate } from "react-router";
import { Link } from "react-router";
import { useScroll } from "framer-motion";
import { loginAuthUser } from "../services/auth/AuthenfiticationUsers";
import { listeCategoriesSansFiltre } from "../services/parametrage/CategorieRequest";
import { VscThreeBars } from "react-icons/vsc";
import SnackbarAlert from "./SnackbarAlert";

const NavBar = () => {
  const navigate = useNavigate();

  const [successMessage, setSuccessMessage] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [snackbarSuccessOpen, setSnackbarOpenSuccess] = useState(false);
  const [snackbarErrorOpen, setSnackbarOpenError] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [userEmail, setUserEmail] = useState("");

  const [decodedTokenVisiteur, setDecodedTokenVisiteur] = useState(null);

  const [searchSomethings, setSearchSomethings] = useState("");

  const [messageAlert, setMessageAlert] = useState("");

  const [categories, setCategories] = useState([]);
  const [searchBoutique, setSearchBoutique] = useState("");

  const [snackbarPosition, setSnackbarPosition] = useState({
    vertical: "bottom",
    horizontal: "center"
  });
  const { vertical, horizontal } = snackbarPosition;

  const handleCloseSnackbarSuccess = () => {
    setSnackbarOpenSuccess(false);
  };

  const handleCloseSnackbarError = () => {
    setSnackbarOpenError(false);
  };

  const onSubmit = () => {
    const msg = "Hello je souhaite avoir plus d'information sur un produit";
    const phoneWithCountryCode = "+1234567890"; // Ensure the phone number includes the country code
    if (msg) {
      const url = `https://wa.me/${"+2250564021616"}?text=${encodeURIComponent(
        msg
      )}`;
      window.open(url, "_blank");
    } else {
      alert("Please insert message to send");
    }
  };

  const favoris = useSelector((state) => state.favorites.items);
  // Nombre de favoris
  const count = favoris.length;

  const handleFacebookLogin = () => {
    window.location.href =
      "https://leadershipforgodbackend-fsm2.onrender.com/visiteurs/auth/facebook";
    // window.location.href = "https://api.leadershipforgod.com/visiteurs/auth/facebook";
  };

  const formatWord = (word) => {
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  };

  const handleSubmit = () => {
    setIsLoading(true);
    const data = {
      password: password,
      email: userEmail ? userEmail : username
    };
    try {
      loginAuthUser(data)
        .then((res) => {
          setIsLoading(false);
          const decodedToken = jwtDecode(res.data.token);

          if (decodedToken.role === "visiteur") {
            localStorage.setItem("compte_visiteur", res.data.token);
            navigate("/");
          } else {
            localStorage.setItem("compte_admin", res.data.token);
            navigate("/dashboard");
          }

          document.getElementById("my_modal_2").close();

          setUserEmail("");
          setUsername("");
          setPassword("");
        })
        .catch((err) => {
          setIsLoading(false);
          if (err.response) {
            setMessageAlert("Identifiants incorrects, réessayer");
          } else {
            setMessageAlert("Une erreur s'est produite, rééssayez!");
          }
        });
    } catch (error) {
      setIsLoading(false);
      console.log("Error 123: " + error);
      setMessageAlert("Quelque chose s'est mal passé, rééssayer");
    }
  };

  const handleSearch = () => {
    if (searchSomethings.length > 0) {
      navigate(`/allproduits/${searchSomethings}`);
      setSearchSomethings("");
    }
    // else{
    //   setSnackbarOpenError(true);
    //     setErrorMessage("Veuillez entrer un mot clé de recherche");
    //   }
  };

  const getListeDesCategories = () => {
    listeCategoriesSansFiltre()
      .then((res) => {
        setCategories(res.data.categories);
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  useEffect(() => {
    getListeDesCategories();
  }, []);

  useEffect(() => {
    function isEventExpired(currentDate, endDateInMilliseconds) {
      // Convert the milliseconds to a Date object
      const endDate = new Date(endDateInMilliseconds);
      // Compare the two dates
      if (currentDate > endDate) {
        // Event has expired
        return true;
      } else {
        // Event is still within time
        return false;
      }
    }

    if (localStorage.getItem("compte_admin")) {
      const currentDate = new Date();
      const decodedToken = jwtDecode(localStorage.getItem("compte_admin"));
      const expirationDate = new Date(decodedToken.exp * 1000);

      if (decodedToken.exp && !isEventExpired(currentDate, expirationDate)) {
        navigate("/dashboard");
      }
    } else if (localStorage.getItem("compte_visiteur")) {
      setDecodedTokenVisiteur(
        jwtDecode(localStorage.getItem("compte_visiteur"))
      );
    }
  }, []);

  return (
    <>
      <div className="navbar bg-white border-secondary border-b-4 py-1 justify-between shadow-xl ">
        <div className="navbar-start relative">
          <div className="drawer-content lg:hidden md:hidden flex">
            {/* Page content here */}
            <label htmlFor="my-drawer" className="drawer-button">
              <img src={IconeFilter} alt="" className="w-6" />
            </label>
          </div>

          <button className="flex absolute xl:left-0 lg:left-0 md:left-0 left-3 items-center justify-center px-2 space-x-2">
            <NavLink to={"/"} className="text-lg font-semibold italic">
              <img src={logo} alt="" className="w-[100px]" />
            </NavLink>
          </button>
        </div>
        <div className="hidden lg:flex">
          <form onSubmit={handleSearch}>
          <label className="input  border-[2px]  input-bordered flex items-center justify-between xl:w-96 lg:w-96  w-full rounded-xl ">
            <input
              type="text"
              className=""
              value={searchSomethings}
              onChange={(e) => setSearchSomethings(e.target.value)}
              placeholder="Article, catégorie, marque ..."
            />
            <button
              onClick={handleSearch}
              className="flex items-center justify-center bg-black p-1.5  rounded-lg cursor-pointer"
            >
              <img src={IconeLoupe} alt="" className="w-5 text-white" />
            </button>
          </label>
          </form>
        </div>
        <div className="navbar-end">
          <div className="xl:hidden lg:hidden dropdown dropdown-bottom dropdown-end">
            <button
              // onClick={handleSearch}
              tabIndex={0}
              className="flex items-center justify-center bg-black p-1.5 px-3 rounded-lg cursor-pointer"
            >
              <img src={IconeLoupe} alt="" className="w-3 text-white" />
            </button>
            <ul
              tabIndex={0}
              className="dropdown-content menu bg-base-100 rounded-box top z-1 w-[300px] p-2 shadow-sm"
            >
             <form onSubmit={handleSearch}>
             <label className="input w-full flex flex-row justify-between items-center">
                <div className="flex flex-row justify-start items-center gap-2">
                  <svg
                    className="h-[1em] opacity-50"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                  >
                    <g
                      strokeLinejoin="round"
                      strokeLinecap="round"
                      strokeWidth="2.5"
                      fill="none"
                      stroke="currentColor"
                    >
                      <circle cx="11" cy="11" r="8"></circle>
                      <path d="m21 21-4.3-4.3"></path>
                    </g>
                  </svg>
                  <input
                    type="text"
                    value={searchSomethings}
                    onChange={(e) => setSearchSomethings(e.target.value)}
                    className="grow"
                    placeholder="Article, marque, categorie .. "
                  />
                </div>
                <kbd onClick={handleSearch} className="kbd kbd-md bg-black">
                  <TbLocationSearch className="w-4 text-white" />
                </kbd>
              </label>
             </form>
            </ul>
          </div>

          <div
            onClick={() => {
              if (localStorage.getItem("compte_visiteur")) {
                navigate("/favoris");
              } else {
                document.getElementById("my_modal_2").showModal();
              }
            }}
            className="indicator cursor-pointer mx-[5px]"
          >
            {count > 0 ? (
              <span className="indicator-item badge ml-2 bg-blue-500 text-white text-xs font-bold rounded-full h-6 w-6 flex items-center justify-center">
                {count}
              </span>
            ) : (
              <span className="indicator-item badge ml-2 bg-blue-500 text-white text-xs font-bold rounded-full h-6 w-6 flex items-center justify-center">
                0
              </span>
            )}
            <IoMdHeartEmpty className="w-6 h-6" />

            {/* <FaRegHeart className="w-6 h-6"  /> */}
          </div>
          <div className="hidden md:flex lg:flex dropdown dropdown-hover">
            <div tabIndex={0} role="button" className=" m-1">
              <button className="flex flex-row justify-start items-center">
                <img src={IconeUser} alt="" className="w-6" />
                <div className=" flex flex-col justify-start items-start pl-2">
                  <span className="text-sm font-normal text-gray-800">
                    Bienvenue
                  </span>
                  {decodedTokenVisiteur && decodedTokenVisiteur !== null ? (
                    <span className="text-[14px] font-semibold text-black ">
                      {decodedTokenVisiteur.nom}
                    </span>
                  ) : (
                    <span className="text-[14px] font-semibold text-black ">
                      Se connecter / s'inscrire
                    </span>
                  )}
                </div>
              </button>
            </div>
            <ul
              tabIndex={0}
              className="dropdown-content menu bg-base-100 rounded-box z-[999] top-12 w-60 ml-[-5rem] p-2 gap-y-1 shadow-lg"
            >
              {decodedTokenVisiteur && decodedTokenVisiteur !== null ? (
                <>
                  <button
                    onClick={() => {
                      localStorage.removeItem("compte_visiteur");
                      localStorage.removeItem("favorites");
                      window.location.reload();
                    }}
                    className="flex justify-center items-center"
                  >
                    <span className="text-md font-bold bg-black text-white px-12 py-3 rounded-2xl ">
                      Se déconnecter
                    </span>
                  </button>
                </>
              ) : (
                <>
                  <button
                    onClick={() =>
                      document.getElementById("my_modal_2").showModal()
                    }
                    className="flex justify-center items-center"
                  >
                    <span className="text-md font-bold bg-black text-white px-12 py-3 rounded-2xl ">
                      Se connecter
                    </span>
                  </button>

                  <button
                    onClick={() =>
                      document.getElementById("my_modal_4").showModal()
                    }
                    className="flex items-start justify-center hover:bg-slate-200 rounded-lg py-2"
                  >
                    <span className="text-sm font-medium text-gray-800">
                      S'inscrire
                    </span>
                  </button>
                </>
              )}

              <button
                onClick={() => {
                  if (localStorage.getItem("compte_visiteur")) {
                    navigate("/favoris");
                  } else {
                    document.getElementById("my_modal_2").showModal();
                  }
                }}
                className="flex flex-row text-sm font-medium text-gray-800 hover:bg-slate-200 rounded-lg py-2  px-12"
              >
                <span> Mes favoris</span>
                {count > 0 ? (
                  <span className="ml-2 bg-blue-500 text-white text-xs font-bold rounded-full h-6 w-6 flex items-center justify-center">
                    {count}
                  </span>
                ) : (
                  <span className="ml-2 bg-blue-500 text-white text-xs font-bold rounded-full h-6 w-6 flex items-center justify-center">
                    0
                  </span>
                )}
              </button>
            </ul>
          </div>

          <button
            onClick={() => document.getElementById("my_modal_2").showModal()}
            className=" lg:hidden md:hidden  flex-row justify-start items-center"
          >
            <img src={IconeUser} alt="" className="w-6" />
          </button>
        </div>

        {/* Formulaire Login*/}
        <dialog id="my_modal_2" className="modal">
          <div className="flex flex-col justify-center ">
            <div className="relative py-3 sm:max-w-xl sm:mx-auto">
              <div className="absolute inset-0 bg-gradient-to-r from-green-400 to-primary-500 shadow-lg transform -skew-y-6 sm:skew-y-0 -rotate-6 rounded-3xl"></div>
              <div className="relative px-4 py-10 bg-white shadow-lg rounded-3xl sm:p-20">
                <form method="dialog">
                  {/* if there is a button in form, it will close the modal */}
                  {/* <div className="absolute left-4 flex top-4 gap-x-2">
                  <h2 className="font-semibold italic">BabiSoldes </h2>
                  <span className="h-2 w-2 mt-3.5 bg-primary rounded-full"></span>{" "}
                </div> */}

                  <button className="btn btn-sm btn-circle btn-ghost absolute right-4 top-4">
                    ✕
                  </button>
                </form>
                {/* Connexion */}
                <div className="flex flex-col items-center ">
                  <div className="max-w-md mx-auto">
                    <h1 className="text-2xl font-semibold sm:py-1 ">
                      Se connecter
                    </h1>
                  <form onSubmit={handleSubmit}>
                  <div className="xl:py-8 lg:py-8 md:py-8 py-4  text-base leading-6 space-y-4 text-gray-700 sm:text-lg sm:leading-7">
                      <label className="input input-bordered flex items-center gap-2">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 16 16"
                          fill="currentColor"
                          className="h-4 w-4 opacity-70"
                        >
                          <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM12.735 14c.618 0 1.093-.561.872-1.139a6.002 6.002 0 0 0-11.215 0c-.22.578.254 1.139.872 1.139h9.47Z" />
                        </svg>
                        <input
                          type="email"
                          value={userEmail}
                          onChange={(e) => setUserEmail(e.target.value)}
                          className="grow"
                          placeholder="Email"
                        />
                      </label>
                      <label className="input input-bordered flex items-center gap-2">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 16 16"
                          fill="currentColor"
                          className="h-4 w-4 opacity-70"
                        >
                          <path
                            fillRule="evenodd"
                            d="M14 6a4 4 0 0 1-4.899 3.899l-1.955 1.955a.5.5 0 0 1-.353.146H5v1.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-2.293a.5.5 0 0 1 .146-.353l3.955-3.955A4 4 0 1 1 14 6Zm-4-2a.75.75 0 0 0 0 1.5.5.5 0 0 1 .5.5.75.75 0 0 0 1.5 0 2 2 0 0 0-2-2Z"
                            clipRule="evenodd"
                          />
                        </svg>
                        <input
                          type="password"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                          className="grow"
                          placeholder="Mot de passe"
                          // value="password"
                        />
                      </label>
                      <div className="text-end text-sm text-gray-700">
                        <Link
                          to="/mot-de-passe-oublie"
                          className="text-blue-500 hover:text-blue-700"
                        >
                          Mot de passe oublié
                        </Link>
                      </div>
                      <div className="w-full flex items-center justify-center">
                        <button
                          disabled={isLoading}
                          className="bg-primary text-white font-semibold flex items-center justify-center rounded-md px-8 py-1 w-full"
                          onClick={handleSubmit}
                        >
                          {!isLoading ? (
                            <span>Connexion</span>
                          ) : (
                            <ThreeDots
                              height="35"
                              width="35"
                              radius="9"
                              color="#fff"
                              ariaLabel="three-dots-loading"
                              wrapperStyle={{}}
                              wrapperClassName=""
                              visible={isLoading}
                            />
                          )}
                        </button>
                      </div>
                      {messageAlert && (
                        <span className="text-red-600 text-sm text-wrap">
                          {messageAlert}
                        </span>
                      )}
                    </div>
                  </form>
                  </div>
                  <div className="w-full flex flex-col gap-3 justify-center">
                    <div className="flex justify-around items-center gap-x-2 ">
                      <hr className="h-0.5 w-full bg-[#979797]"></hr>
                      <h2 className="text-nowrap text-xs text-[#8d8d8d]">
                        Accès rapide avec
                      </h2>
                      <hr className="h-0.5 w-full bg-[#979797]"></hr>
                    </div>

                    <div className="flex flex-row items-center justify-center gap-x-3">
                      <button className="flex items-center bg-white border gap-x-2 border-gray-300 rounded-lg shadow-md px-4 py-2 text-sm font-medium text-gray-800 hover:border-secondary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500">
                        <img
                          src={logoGoogle}
                          className="w-6"
                          alt="logo google"
                        />
                      </button>
                      <button className="flex items-center bg-white border gap-x-2 border-gray-300 rounded-lg shadow-md px-4 py-2 text-sm font-medium text-gray-800 hover:border-secondary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500">
                        <img
                          src={logoFacebook}
                          className="w-6"
                          alt="logo google"
                        />
                      </button>
                    </div>

                    <div className="flex flex-col items-center gap-x-1 mt-2">
                      <span className="text-xs text-gray-700 ">
                        Vous n'avez pas de compte?{" "}
                      </span>
                      <div className="flex flex-row gap-x-2 mt-2">
                        <button
                          onClick={() => {
                            document.getElementById("my_modal_2").close();
                            document.getElementById("my_modal_4").showModal();
                          }}
                          className="text-blue-500 text-xs underline hover:text-blue-700"
                        >
                          Inscrivez-vous
                        </button>
                        {/* <span className="text-md text-[#8d8d8d]">Ou</span> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </dialog>

        {/* Formulaire boutique */}
        <dialog id="my_modal_3" className="modal">
          <div className="flex flex-col justify-center">
            <div className="relative overscroll-y-auto">
              <div className="absolute inset-0 bg-gradient-to-r from-cyan-400 to-sky-500 shadow-lg transform -skew-y-6 sm:skew-y-0 -rotate-6 rounded-3xl"></div>
              <div className="relative px-4 py-10 bg-white shadow-lg rounded-3xl sm:p-10">
                <form method="dialog">
                  {/* <div className="absolute left-4 flex top-4 gap-x-2">
                  <h2 className="font-semibold italic">BabiSoldes</h2>
                  <span className="h-2 w-2 mt-3.5 bg-primary rounded-full"></span>
                </div> */}
                  <button className="btn btn-sm btn-circle btn-ghost absolute right-4 top-4">
                    ✕
                  </button>
                </form>

                {/* Inscription Boutique */}
                <div className="flex flex-col items-center">
                  <div className="max-w-md mx-auto">
                    <h1 className="text-xl font-semibold pb-4">
                      Inscription Boutique
                    </h1>
                    <div className="text-base leading-6 space-y-4 text-gray-700 sm:text-lg sm:leading-7">
                      <div className="space-y-2">
                        <label className="input input-bordered flex items-center gap-2">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth="1.5"
                            stroke="currentColor"
                            className="w-4 h-4"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M13.19 8.688a4.5 4.5 0 0 1 1.242 7.244l-4.5 4.5a4.5 4.5 0 0 1-6.364-6.364l1.757-1.757m13.35-.622 1.757-1.757a4.5 4.5 0 0 0-6.364-6.364l-4.5 4.5a4.5 4.5 0 0 0 1.242 7.244"
                            />
                          </svg>
                          <input
                            type="text"
                            className="grow"
                            placeholder="Nom officiel (registre du commerce)"
                            required
                          />
                        </label>
                        <label className="input input-bordered flex items-center gap-2">
                          📍
                          <input
                            type="text"
                            className="grow"
                            placeholder="Adresse complète (ex: Cocody Riviera-Anono)"
                            required
                          />
                        </label>

                        <label className="input input-bordered flex items-center gap-2">
                          +225
                          <input
                            type="tel"
                            pattern="[0-9]{10}"
                            className="grow"
                            placeholder="Numéro de téléphone"
                            required
                          />
                        </label>

                        <label className="input input-bordered flex items-center gap-2">
                          @
                          <input
                            type="email"
                            className="grow"
                            placeholder="Email professionnel"
                            required
                          />
                        </label>

                        <label className="input input-bordered flex items-center gap-2">
                          🔗
                          <input
                            type="url"
                            className="grow"
                            placeholder="Site web/page sociale"
                          />
                        </label>
                      </div>

                      {/* Section 2 : Preuves de légitimité */}
                      <div className="space-y-4">
                        <div className="form-control">
                          <label className="label">
                            <span className="label-text">
                              Pièce d'identité du responsable
                            </span>
                          </label>
                          <input
                            type="file"
                            className="file-input file-input-bordered w-full"
                            accept="image/*,.pdf"
                            required
                          />
                        </div>
                      </div>

                      {/* Bouton d'inscription */}
                      <div className="w-full pt-4">
                        <button className="bg-primary text-white font-semibold rounded-md px-8 py-2 w-full hover:bg-primary-dark">
                          S'inscrire
                        </button>
                      </div>
                    </div>
                  </div>

                  {/* Lien connexion */}
                  <div className="flex items-center gap-x-1 mt-4 ">
                    <span className="text-xs text-gray-700 underline">
                      Déjà inscrit?
                    </span>
                    <button
                      onClick={() => {
                        document.getElementById("my_modal_3").close();
                        document.getElementById("my_modal_2").showModal();
                      }}
                      className="text-blue-500 text-xs underline hover:text-blue-700"
                    >
                      Connectez-vous
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </dialog>

        {/* Formulaire Client */}
        <dialog id="my_modal_4" className="modal">
          {" "}
          {/* Nouvel ID pour différencier des autres modals */}
          <div className="flex flex-col justify-center">
            <div className="relative overscroll-y-auto">
              <div className="absolute inset-0 bg-gradient-to-r from-green-400 to-green-500 shadow-lg transform -skew-y-6 sm:skew-y-0 -rotate-6 rounded-3xl"></div>
              <div className="relative px-4 md:px-16 lg:px-16 py-4 bg-white shadow-lg rounded-3xl ">
                <form method="dialog">
                  <button className="btn btn-sm btn-circle btn-ghost absolute right-4 top-4">
                    ✕
                  </button>
                </form>

                <div className="flex flex-col items-center">
                  <div className="max-w-md mx-auto">
                    <h1 className="text-2xl font-semibold sm:py-1">
                      S'inscrire
                    </h1>

                    <div className="xl:py-8 lg:py-8 md:py-8 py-4 text-base leading-6 space-y-4 text-gray-700 sm:text-lg sm:leading-7">
                      {/* Boutons sociaux */}
                      <div className="flex flex-row items-center justify-center gap-x-3">
                        <GoogleOAuthProvider
                          clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}
                        >
                          <GoogleLogin
                            /* bouton icône-only */
                            type="icon" // ne garde que l’icône :contentReference[oaicite:4]{index=4}
                            shape="" // rendu circulaire
                            size="large" // taille medium
                            theme="filled_blue" // fond plein bleu
                            logo_alignment="center" // logo centré
                            width="30px" // largeur fixe
                            onSuccess={(credentialResponse) => {
                              console.log(
                                "Token reçu:",
                                credentialResponse.credential
                              );

                              fetch(
                                // "https://api.babisoldes.com/visiteurs/auth/google",
                                // "http://192.168.1.4:5000/visiteurs/auth/google",
                                "https://leadershipforgodbackend-fsm2.onrender.com/visiteurs/auth/google",

                                {
                                  method: "POST",
                                  headers: {
                                    "Content-Type": "application/json"
                                  },
                                  body: JSON.stringify({
                                    token: credentialResponse.credential
                                  })
                                }
                              )
                                .then((response) => {
                                  if (!response.ok) {
                                    throw new Error("Erreur réseau");
                                  }
                                  return response.json();
                                })
                                .then((data) => {
                                  console.log("Réponse du serveur:", data);
                                  if (data.token) {
                                    localStorage.setItem(
                                      "compte_visiteur",
                                      data.token
                                    );

                                    document
                                      .getElementById("my_modal_4")
                                      .close();

                                    setSuccessMessage(
                                      "Félicitation compte créé avec succès"
                                    );
                                    setSnackbarOpenSuccess(true);
                                    window.location.reload();
                                  }
                                })
                                .catch((error) => {
                                  console.error("Erreur:", error);
                                });
                            }}
                            onError={() => {
                              console.log("Login Failed");
                            }}
                          />
                        </GoogleOAuthProvider>
                        <button
                          onClick={handleFacebookLogin}
                          className="flex items-center bg-white border-2 gap-x-2 border-blue-600 rounded-md  px-[7px] py-[7px]  text-sm font-medium text-gray-800 hover:border-secondary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
                        >
                          <img
                            src={logoFacebook}
                            className="w-6"
                            alt="logo google"
                          />
                        </button>
                      </div>

                      {/* Séparateur */}
                      <div className="flex items-center gap-2 my-6">
                        <hr className="flex-grow border-gray-300" />
                        <span className="text-sm text-gray-500">OU</span>
                        <hr className="flex-grow border-gray-300" />
                      </div>

                      {/* Formulaire classique */}
                      <form>
                        <div className="space-y-4">
                          <div className="flex flex-col gap-4">
                            <label className="input input-bordered flex items-center gap-2 flex-grow">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                strokeWidth="1.5"
                                stroke="currentColor"
                                className="w-4 h-4"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  d="M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z"
                                />
                              </svg>
                              <input
                                type="text"
                                className="grow"
                                placeholder="Nom & Prénoms"
                                required
                              />
                            </label>
                          </div>

                          <label className="input input-bordered flex items-center gap-2">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 16 16"
                              fill="currentColor"
                              className="w-4 h-4 opacity-70"
                            >
                              <path d="M2.5 3A1.5 1.5 0 0 1 4 1.5h8A1.5 1.5 0 0 1 13.5 3v1.351a14.455 14.455 0 0 1-3.288 9.154l-2.014 2.233a.5.5 0 0 1-.744 0l-2.014-2.233A14.454 14.454 0 0 1 2.5 4.351V3Zm3.75 4.25a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0Zm2.5 0a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0Zm2.5 0a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0Z" />
                            </svg>
                            <input
                              type="email"
                              className="grow"
                              placeholder="Email"
                              required
                            />
                          </label>

                          <label className="input input-bordered flex items-center gap-2">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 16 16"
                              fill="currentColor"
                              className="w-4 h-4 opacity-70"
                            >
                              <path
                                fillRule="evenodd"
                                d="M14 6a4 4 0 0 1-4.899 3.899l-1.955 1.955a.5.5 0 0 1-.353.146H5v1.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-2.293a.5.5 0 0 1 .146-.353l3.955-3.955A4 4 0 1 1 14 6Zm-4-2a.75.75 0 0 0 0 1.5.5.5 0 0 1 .5.5.75.75 0 0 0 1.5 0 2 2 0 0 0-2-2Z"
                                clipRule="evenodd"
                              />
                            </svg>
                            <input
                              type="password"
                              className="grow"
                              placeholder="Mot de passe"
                              required
                            />
                          </label>
                        </div>
                      </form>

                      <div className="w-full pt-2">
                        <button className="bg-primary text-white font-semibold rounded-md px-8 py-2 w-full hover:bg-secondary-dark">
                          Créer mon compte
                        </button>
                      </div>
                    </div>
                  </div>

                  {/* Liens de navigation */}
                  <div className="flex flex-col items-center gap-1  text-sm">
                    <button
                      onClick={() => {
                        document.getElementById("my_modal_4").close();
                        document.getElementById("my_modal_2").showModal();
                      }}
                      className="text-blue-500 hover:text-blue-700 underline"
                    >
                      J'ai déjà un compte ? Se connecter
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </dialog>
      </div>
      <div className="hidden w-full lg:px-0 md:px-0 xl:flex lg:flex px-6 items-center flex-row  bg-slate-50 gap-x-2 shadow-lg">
        <div className="hidden lg:flex md:flex dropdown dropdown-hover ml-4">
          <div
            tabIndex={0}
            // role="button"
            className=" flex flex-row justify-center items-center px-2 py-1 gap-x-2  rounded-lg cursor-pointer bg-secondary "
          >
            <VscThreeBars className="text-md text-white" />
            <span className="text-md text-white font-semibold">
              Toutes les catégories
            </span>
            <img src={arrowDown} className="w-7" alt="" />
          </div>
          <ul
            tabIndex={0}
            className="dropdown-content menu bg-[#f5f5f5] rounded-box z-[100] top-8  w-60 p-4 gap-1 shadow-xl overflow-y-auto "
          >
            <div className="overflow-y-auto max-h-[350px] gap-y-2 flex flex-col ">
              {categories.map((category, index) => (
                <NavLink
                  key={index}
                  to={`/allproduits/${category.nom}`}
                  className="flex flex-row justify-start items-center cursor-pointer space-x-2  hover:bg-primary hover:text-white py-1 px-2 hover:font-semibold  rounded-md text-sm"
                >
                  <img
                    src={category.image}
                    alt="Carousel Item 1"
                    className="w-[30px] h-[30px] rounded-md"
                  />
                  <span className="text-[16px]">
                    {" "}
                    {formatWord(category.nom)}
                  </span>
                </NavLink>
              ))}
            </div>
          </ul>
        </div>

        <div className="dropdown">
          <div
            tabIndex={0}
            className=" bg-secondary  cursor-pointer flex flex-row items-center justify-center text-white px-2 py-1 rounded-lg m-1"
          >
            <span className="font-semibold text-sm"> Nos services</span>
            <span>
              <img src={arrowDown} className="w-7" alt="" />
            </span>
          </div>
          <ul
            tabIndex={0}
            className="menu dropdown-content bg-gray-100 rounded-box left-[-5rem]  z-1 w-60 pl-2 p-2 shadow-lg"
          >
            <NavLink
              to={"/service-installation"}
              className="font-medium text-[16px] hover:bg-primary hover:text-white py-2 px-2 hover:font-semibold rounded-md"
            >
              Installation
            </NavLink>
            <NavLink
              to={"/service-technique"}
              className="font-medium text-[16px] hover:bg-primary hover:text-white py-2 px-2 hover:font-semibold rounded-md"
            >
              Technique
            </NavLink>
            <NavLink
              to={"/service-maintenance"}
              className="font-medium text-[16px] hover:bg-primary hover:text-white py-2 px-2 hover:font-semibold rounded-md"
            >
              Réparation & dépannage
            </NavLink>
          </ul>
        </div>

        <ul className="lg:flex xl:flex md:flex hidden menu py-2 items-center gap-2 justify-center menu-vertical lg:menu-horizontal  rounded-box">
          {/* bouton */}
          <li>
            <button
              onClick={() => navigate("/")}
              className="hover:bg-primary hover:text-white"
            >
              <span className="text-left text-sm lg:text-[16px] md:text-[14px]">
                Accueil
              </span>
            </button>
          </li>
          <li>
            <button
              onClick={() => navigate("/apropos")}
              className="hover:bg-primary hover:text-white"
            >
              <span className="text-left text-sm lg:text-[16px] md:text-[14px]">
                Apropos
              </span>
            </button>
          </li>
          <li>
            <button
              onClick={onSubmit}
              className="flex flex-row justify-center items-center gap-1 hover:bg-primary hover:text-white"
            >
              <span className="text-left text-sm lg:text-[16px] md:text-[14px]">
                Contacter-nous
              </span>
              <img src={LogoWhatSapp} className="w-5 h-5" />
            </button>
          </li>
        </ul>
      </div>
      <div className="drawer">
        <input id="my-drawer" type="checkbox" className="drawer-toggle" />

        <div className="drawer-side">
          <label
            htmlFor="my-drawer"
            aria-label="close sidebar"
            className="drawer-overlay"
          ></label>
          <div className="menu bg-base-200 text-base-content min-h-full overflow-y-auto w-80 ">
            {/* Sidebar content here */}
            <label
              htmlFor="my-drawer"
              aria-label="close sidebar"
              className="drawer-overlay"
            >
              <div className="flex flex-row justify-start items-center gap-x-2 border-y-[1px] py-2 border-y-secondary w-full">
                <img src={IconeHome} className=" w-6" />
                <h2 className="text-lg font-semibold italic">GodleaderShop</h2>
              </div>
            </label>

            <div className="flex flex-row justify-start items-center my-2">
              <h2 className="font-bold text-lg">Toutes les catégories</h2>
            </div>
            <div className="overflow-y-auto h-full gap-y-2 flex flex-col ">
              {categories.map((category, index) => (
                <NavLink
                  key={index}
                  to={`/allproduits/${category.nom}`}
                  className="flex flex-row items-center space-x-2 py-2 rounded-md pl-3 hover:font-bold hover:bg-gray-200 text-[17px]"
                >
                  <img src={category.image} alt="" className="w-6 rounded-6" />
                  <span> {formatWord(category.nom)}</span>
                </NavLink>
              ))}
            </div>
          </div>
        </div>
      </div>

      <SnackbarAlert
        vertical={vertical}
        horizontal={horizontal}
        snackbarSuccessOpen={snackbarSuccessOpen}
        handleCloseSnackbarSuccess={handleCloseSnackbarSuccess}
        successMessage={successMessage}
        snackbarErrorOpen={snackbarErrorOpen}
        handleCloseSnackbarError={handleCloseSnackbarError}
        errorMessage={errorMessage}
      />
    </>
  );
};

export default NavBar;
